import { render, staticRenderFns } from "./currencyIncome.vue?vue&type=template&id=387d9483"
import script from "./currencyIncome.vue?vue&type=script&lang=js"
export * from "./currencyIncome.vue?vue&type=script&lang=js"
import style0 from "./currencyIncome.vue?vue&type=style&index=0&id=387d9483&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports